export default function ShopReducer(state, action) {
    switch (action.type) {
        case STATUS.OPEN_CART:
            const result = {
                ...state,
                openCard: true
            }

            if (action.data) {
                // result.activeProduct = action.data;
                result.openProduct = action.data;
            }

            return result;

        case STATUS.CLOSE_CART:
            return {
                ...state,
                openCard: false,
                openForm: false,
                // activeProduct: false,
                openProduct: false
            };
        
        case STATUS.OPEN_PRODUCT:
            return {
                ...state,
                // activeProduct: action.data,
                openProduct: action.data,
                openForm: false
            };

        case STATUS.CLOSE_PRODUCT:
            return {
                ...state,
                openForm: false,
                openProduct: false
            };
        
        case STATUS.OPEN_FORM:
            return {
                ...state,
                openForm: action.data,
                // activeProduct: action.data,
                // openProduct: action.data
            };

        case STATUS.CLOSE_FORM:
            return {
                ...state,
                openForm: false
                // openProduct: false
            };

        case STATUS.OPEN_PRODUCT_OPTIONS:
            return {
                ...state,
                openProductOptions: action.data
            };

        case STATUS.CLOSE_PRODUCT_OPTIONS:
            return {
                ...state,
                openProductOptions: null
            };

        case STATUS.OPEN_EDIT_PRODUCT_OPTIONS:
            return {
                ...state,
                openEditProductOptions: action.data
            };

        case STATUS.CLOSE_EDIT_PRODUCT_OPTIONS:
            return {
                ...state,
                openEditProductOptions: null
            };
    
        default:
            return state
    }
}

const STATUS = {
    OPEN_CART: 'shop:open:cart',
    CLOSE_CART: 'shop:close:cart',
    OPEN_PRODUCT: 'shop:open:product',
    CLOSE_PRODUCT: 'shop:close:product',
    OPEN_FORM: 'shop:open:form',
    CLOSE_FORM: 'shop:close:form',
    OPEN_PRODUCT_OPTIONS: 'shop:open:product:options',
    CLOSE_PRODUCT_OPTIONS: 'shop:close:product:options',
    OPEN_EDIT_PRODUCT_OPTIONS: 'shop:open:edit:product:options',
    CLOSE_EDIT_PRODUCT_OPTIONS: 'shop:close:edit:product:options',
}

export const SHOP_ACTIONS = STATUS

export const createShopInitialState = () => {
    return {
        openCard: null,
        // activeProduct: null,
        openProduct: null,
        openForm: null,
        openProductOptions: null,
        openEditProductOptions: null,
    }
}
